export default "data:text/javascript;base64,aW1wb3J0IE1hcEJhaWR1IGZyb20gJy4vTWFwQmFpZHUudnVlJzsKZXhwb3J0IGRlZmF1bHQgTWFwQmFpZHU7Cg=="